import React, { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { api } from "../lib/api";
import { toast } from "sonner";

export default function ChangePassword() {
  const [form, setForm] = useState({ current_password: "", new_password: "", confirm_password: "" });
  const [saving, setSaving] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (form.new_password.length < 6) return toast.error("New password must be at least 6 characters");
    if (form.new_password !== form.confirm_password) return toast.error("Passwords do not match");
    setSaving(true);
    try {
      await api.post("/auth/change-password", {
        current_password: form.current_password,
        new_password: form.new_password,
      });
      toast.success("Password updated");
      setForm({ current_password: "", new_password: "", confirm_password: "" });
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Failed to update password");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="p-6 md:p-10 max-w-lg mx-auto" data-testid="change-password-root">
      <Link
        to="/app/settings"
        className="inline-flex items-center gap-2 text-sm font-medium mb-4"
        style={{ color: "var(--text-muted)" }}
        data-testid="change-password-back"
      >
        <ArrowLeft size={16} /> Back to settings
      </Link>

      <h1 className="font-display font-bold text-3xl">Change password</h1>
      <p className="text-sm mt-1 mb-8" style={{ color: "var(--text-muted)" }}>
        Enter your current password, then choose a new one.
      </p>

      <form onSubmit={submit} className="card-soft p-6 space-y-4">
        <Field
          label="Current password"
          type="password"
          testid="change-password-current"
          value={form.current_password}
          onChange={(v) => setForm({ ...form, current_password: v })}
          required
        />
        <Field
          label="New password"
          type="password"
          testid="change-password-new"
          value={form.new_password}
          onChange={(v) => setForm({ ...form, new_password: v })}
          required
          hint="At least 6 characters"
        />
        <Field
          label="Confirm new password"
          type="password"
          testid="change-password-confirm"
          value={form.confirm_password}
          onChange={(v) => setForm({ ...form, confirm_password: v })}
          required
        />
        <button
          type="submit"
          disabled={saving}
          data-testid="change-password-save"
          className="w-full h-11 rounded-md text-white font-semibold tactile-btn disabled:opacity-60"
          style={{ background: "var(--primary)" }}
        >
          {saving ? "Saving..." : "Update password"}
        </button>
      </form>
    </div>
  );
}

function Field({ label, value, onChange, type = "text", testid, required, hint }) {
  return (
    <div>
      <label className="text-sm font-medium">{label}</label>
      <input
        data-testid={testid}
        required={required}
        type={type}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="mt-1 w-full h-11 px-3 rounded-md border bg-white"
        style={{ borderColor: "var(--border-soft)" }}
      />
      {hint && <p className="text-xs mt-1" style={{ color: "var(--text-muted)" }}>{hint}</p>}
    </div>
  );
}
